import React from 'react'
import { Step } from 'react-joyride'
import IDS from './ids'

const getID = (id: string) => `#${id}`

export const newslettersPageSteps: Step[] = [
  {
    target: getID(IDS.CHOOSE_SCOPE),
    content: 'Wybierz zakres tematyczny',
  },
]

export const previewPageSteps: Step[] = [
  {
    target: getID(IDS.BRIEFCASE),
    content: 'Dokumenty udostępniane przez Dział Prawny EcoMS.',
  },
  {
    target: getID(IDS.CHART),
    content:
      'Zobacz wyniki audytu w liczbach. Każdy audytowany zakres wymagań prawnych posiada swój własny wykres.',
  },
  {
    target: getID(IDS.DECISIONS),
    content: 'Decyzje administracyjne dotyczące tej lokalizacji.',
  },
  {
    target: getID(IDS.ASPECTS),
    content: 'Aspekty środowiskowe zidentyfikowane dla tej lokalizacji.',
  },
  {
    target: getID(IDS.DOCUMENTS),
    content: 'Dokumenty udostępnione przez Twoją organizację.',
  },
  {
    target: getID(IDS.NEWSLETTERS),
    content: 'Archiwum informacji o zmieniających się przepisach.',
  },
  {
    target: getID(IDS.HISTORY),
    content: 'Archiwum raportów z audytów oceny zgodności.',
  },
  {
    target: getID(IDS.TABS),
    content: 'Wybierz interesujący Cię zakres tematyczny',
  },
  {
    target: getID(IDS.AUDIT_ICON),
    content: 'Ikona wskazuje, które zakresy tematyczne były audytowane.',
  },
  {
    target: getID(IDS.ACTS_REGISTER),
    content: 'Rejestr aktów prawnych z wybranego zakresu tematycznego.',
  },
]

export const previewPageStepsBasic: Step[] = [
  {
    target: getID(IDS.BRIEFCASE),
    content: 'Dokumenty udostępniane przez Dział Prawny EcoMS.',
  },
  {
    target: getID(IDS.CHART),
    content:
      'Zobacz wyniki audytu w liczbach. Każdy audytowany zakres wymagań prawnych posiada swój własny wykres.',
  },
  {
    target: getID(IDS.DECISIONS),
    content: 'Decyzje administracyjne dotyczące tej lokalizacji.',
  },
  {
    target: getID(IDS.ASPECTS),
    content: 'Aspekty środowiskowe zidentyfikowane dla tej lokalizacji.',
  },
  {
    target: getID(IDS.DOCUMENTS),
    content: 'Dokumenty udostępnione przez Twoją organizację.',
  },
  {
    target: getID(IDS.NEWSLETTERS),
    content: 'Archiwum informacji o zmieniających się przepisach.',
  },
  {
    target: getID(IDS.HISTORY),
    content: 'Archiwum raportów z audytów oceny zgodności.',
  },
  {
    target: getID(IDS.TABS),
    content: 'Wybierz interesujący Cię zakres tematyczny',
  },

  {
    target: getID(IDS.ACTS_REGISTER),
    content: 'Rejestr aktów prawnych z wybranego zakresu tematycznego.',
  },
]

export const requirementSteps: Step[] = [
  {
    target: getID(IDS.REQUIREMENT_ASPECTS),
    content: 'Wstaw aspekt środowiskowy związany z tym wymaganiem prawnym.',
  },
  {
    target: getID(IDS.REQUIREMENT_DECISIONS),
    content: 'Wstaw decyzję administracyjną związaną z tym wymaganiem prawnym.',
  },
  {
    target: getID(IDS.REQUIREMENT_DOCUMENT),
    content: 'Wstaw dokument związany z tym wymaganiem prawnym.',
  },

  {
    target: getID(IDS.CLIENT_CLIENT_BASIC_REQUIREMENT_ASPECTS),
    content: 'Aspekty środowiskowe związane z tym wymaganiem prawnym.',
  },
  {
    target: getID(IDS.CLIENT_CLIENT_BASIC_REQUIREMENT_DECISIONS),
    content: 'Decyzje administracyjne związane z tym wymaganiem prawnym.',
  },
  {
    target: getID(IDS.CLIENT_CLIENT_BASIC_REQUIREMENT_DOCUMENT),
    content: 'Dokumenty związane z tym wymaganiem prawnym.',
  },
  {
    target: getID(IDS.REQUIREMENT_BACK),
    content: 'Powrót do poprzedniego widoku.',
  },
  {
    target: getID(IDS.REQUIREMENT_ASSESSMENT),
    content: `Możesz dodać własną ocenę realizacji tego wymagania.
       Uzasadnij swoją ocenę w polu poniżej. Na kolejnym audycie audytor zweryfikuję zasadność zmiany statusu oceny.`,
  },
]

export const requirementStepsBasic: Step[] = [
  {
    target: getID(IDS.REQUIREMENT_BACK),
    content: 'Powrót do poprzedniego widoku.',
  },
]

export const administrationSteps: Step[] = [
  {
    target: getID(IDS.ADMINISTRATION_BUTTON),
    content: `Wejdź do panelu administratora.
      W panelu administratora możesz tworzyć i usuwać użytkowników aplikacji w Twojej organizacji. Możesz również zarządzać utworzonymi już użytkownikami.`,
  },
  {
    target: getID(IDS.ADD_USER),
    content: 'Dodaj nowego użytkownika',
  },
  {
    target: getID(IDS.ADD_USER_TYPE),
    content: (
      <div>
        <p>Wybierz poziom uprawnień użytkownika.</p>
        <p>
          <strong>Podstawowy</strong> – Posiada wyłącznie uprawnienia do
          przeglądania zasobów bazy wymagań prawnych, w tym aspektów, decyzji i
          innych dokumentów. Może również pobierać te zasoby. Nie ma jednak
          dostępu do wyników audytu oceny zgodności oraz nie posiada żadnych
          uprawnień edycyjnych.
        </p>
        <p>
          <strong>Rozszerzony</strong> – Posiada uprawnienia do przeglądania
          zasobów bazy wymagań prawnych, w tym aspektów, decyzji i innych
          załączonych dokumentów. Może również pobierać te zasoby. Posiada także
          dostęp do wyników audytu oceny zgodności. Nie ma żadnych uprawnień
          edycyjnych.
        </p>
        <p>
          <strong>Specjalista</strong> – Posiada pełen dostęp do bazy wymagań
          prawnych oraz wyników audytu oceny zgodności. Może również dodawać
          decyzje, aspekty i inne dokumenty oraz komentować wyniki audytu.
        </p>
        <p>
          <strong>Administrator</strong> – Może tworzyć i usuwać użytkowników.
          Może również zarządzać utworzonymi już użytkownikami. Posiada pełen
          dostęp do bazy wymagań prawnych oraz wyników audytu oceny zgodności.
          Może również dodawać decyzje, aspekty i inne dokumenty oraz komentować
          wyniki audytu.
        </p>
      </div>
    ),
    styles: {
      options: {
        width: 800,
      },
    },
  },
  {
    target: getID(IDS.LOCATIONS),
    content: 'Wybierz lokalizacje jakie zostaną udostępnione użytkownikowi.',
  },
]

export const addUserDialogSteps: Step[] = [
  {
    target: getID(IDS.ADD_USER_TYPE),
    content: `Wybierz poziom uprawnień użytkownika. 
    
      Podstawowy – Posiada wyłącznie uprawnienia do przeglądania zasobów bazy wymagań prawnych, w tym aspektów, decyzji i innych dokumentów. Może również pobierać te zasoby. Nie ma jednak dostępu do wyników audytu oceny zgodności oraz nie posiada żadnych uprawnień edycyjnych.

      Rozszerzony – Posiada uprawnienia do przeglądania zasobów bazy wymagań prawnych, w tym aspektów, decyzji i innych załączonych dokumentów. Może również pobierać te zasoby. Posiada także dostęp do wyników audytu oceny zgodności. Nie ma żadnych uprawnień edycyjnych.

      Specjalista – Posiada pełen dostęp do bazy wymagań prawnych oraz wyników audytu oceny zgodności. Może również dodawać decyzje, aspekty i inne dokumenty oraz komentować wyniki audytu.
      
      Administrator - Może tworzyć i usuwać użytkowników. Może również zarządzać utworzonymi już użytkownikami. Posiada pełen dostęp do bazy wymagań prawnych oraz wyników audytu oceny zgodności. Może również dodawać decyzje, aspekty i inne dokumenty oraz komentować wyniki audytu.`,
  },
]

export const selectLocationPageStepsAdmin: Step[] = [
  {
    target: getID(IDS.ADMINISTRATION_BUTTON),
    content: `Wejdź do panelu administratora.
      W panelu administratora możesz tworzyć i usuwać użytkowników aplikacji w Twojej organizacji. Możesz również zarządzać utworzonymi już użytkownikami.`,
  },
  {
    target: getID(IDS.SELECT_LOCATION_OPEN),
    content: `Otwórz bazę wymagań prawnych dla tej lokalizacji.`,
  },
]

export const selectLocationPageStepsClient: Step[] = [
  {
    target: getID(IDS.SELECT_LOCATION_OPEN),
    content: `Otwórz bazę wymagań prawnych dla tej lokalizacji.`,
  },
]
